import { createContext } from 'react'

import { createRemoteTableStore } from '../store/createStore'

export const RemoteTableStoreContext = createContext<
  ReturnType<typeof createRemoteTableStore> | undefined
>(undefined)
